<template lang="pug">
tr(:key="device.id" @contextmenu="$emit('contextmenu', $event)")
  td {{index}}
  td.noWrap.state
    button.btn.btn-xs.btn-default.disabled(type="button" style="position: relative" @mouseover="showId = device.id" @mouseleave="showId = false")
      i.fas.fa-inverse.fa-eye
      .prev(v-if="showId === device.id" :style="{'background-image': 'url(' + screenShot + ')'}")
    button.btn.btn-xs.disabled(type="button" :class="device.failure || device.kiosk_status | eqStatusBtn" v-tooltip.bottom="$options.filters.translate('Hardware status', lang) + kioskStatus")
      i.fa.fa-inverse(:class="device.failure || device.kiosk_status | eqStatusIcon")
    button.btn.btn-xs.disabled(type="button" :class="printerStatusClass" v-tooltip.bottom="$options.filters.translate('Pritner status', lang)")
      i.fa.fa-inverse.fa-print
    button.btn.btn-xs.disabled(type="button" :class="printerPaperStatusClass" v-tooltip.bottom="$options.filters.translate('Printer paper', lang)")
      i.fa.fa-inverse.fa-toilet-paper
    button.btn.btn-xs.disabled(type="button" :class="terminalStatusClass" v-tooltip.bottom="$options.filters.translate('Payment Term. State', lang)")
      i.fa.fa-inverse.fa-credit-card
    button.btn.btn-xs.disabled(type="button" :class="hbStatus" v-tooltip.bottom="$options.filters.translate('Pulse', lang)")
      i.fa.fa-heartbeat.fa-inverse(:class="hbStatusPulse")
  td {{device.hbtime | formatDateTime}}
  td.noWrap
    button.btn.btn-xs.btn-default.text-primary(type="button" @click="$emit('refreshSs', device.id)" v-tooltip.bottom="$options.filters.translate('Refresh screenshot', lang)")
      i.fas.fa-camera
    div.secure(v-if="$store.getters.hasRole(['admin', 'manager'])")
      button.btn.btn-xs.btn-default.text-info(type="button" @click="$emit('restartView', device.id)" v-tooltip.bottom="$options.filters.translate('Restart Chrome', lang)")
        i.fab.fa-chrome
      button.btn.btn-xs.btn-default.text-warning(type="button" @click="$emit('restartApp', device.id)" v-tooltip.bottom="$options.filters.translate('Restart App', lang)")
        i.fa.fa-undo
      button.btn.btn-xs.btn-default.text-danger(type="button" @click="$emit('restartDevice', device.id)" v-tooltip.bottom="$options.filters.translate('Restart Kiosk', lang)")
        i.fa.fa-power-off
      button.btn.btn-xs.btn-default.btn-sm.text-success(v-if="device.enabled && $store.getters.hasRole(['admin', 'manager']) && isEnableVersionValid(device.version)" @click="$emit('enableDevice', {'id': device.id, 'enable': false});" type="button" v-tooltip.bottom="$options.filters.translate('Deactivate', lang)")
        i.fa.fa-tablet-alt
      button.btn.btn-xs.btn-default.btn-sm.text-danger(v-if="!device.enabled && $store.getters.hasRole(['admin', 'manager']) && isEnableVersionValid(device.version)" @click="$emit('enableDevice', {'id': device.id, 'enable': true});" type="button" v-tooltip.bottom="$options.filters.translate('Activate', lang)")
        i.fa.fa-tablet-alt
    div.secure.spaceL(v-if="$store.getters.hasRole(['admin'])")
      button.btn.btn-xs.btn-default.text-danger(type="button" @click="$emit('removeDevice', device.id)" v-tooltip.bottom="$options.filters.translate('Delete', lang)")
        i.fa.fa-trash

  td
    span.rowName(v-tooltip.right="''+device.id" @click="openDetail") {{device.name}}
  td {{device.description}}
  td {{device.localIP}}
  td {{device.version}}
  td {{software | cookbookVersion}}
  td {{hardware | hardwareMotherboardFormat}}
  td {{hardware | hardwareCpuFormat}}
  td {{device.cpuLoad | cpuFormat}}
  td {{device.cpuTemp | tempFormat}}
  td {{device.diskUsagePercent}} %
</template>

<script>
import Vue from 'vue'
import semver from 'semver'

export default {
  name: 'device',
  props: ['lang', 'index', 'device', 'showModal'],
  data () {
    return {
      showId: false,
      hbStatusSetInterval: undefined,
      hbStatus: 'btn-success'
    }
  },
  beforeDestroy () {
    clearInterval(this.hbStatusSetInterval)
  },
  computed: {
    screenShot () {
      let sshotPath = '/static/no-sshot.png'
      if (this.device.screenshot && this.device.screenshot.length > 0 && this.device.screenshot[0].filepath.length > 0) {
        sshotPath = this.device.screenshot[0].filepath
      }
      return sshotPath
    },
    hbStatusPulse () {
      if (this.hbStatus === 'btn-success') {
        return 'animated infinite pulse'
      }
    },
    kioskStatus () {
      return Vue.filter('hwStatus')(this.device, this.lang.lang)
    },
    software () {
      return this.device.software
    },
    hardware () {
      return this.device.hardware
    },
    printerStatusClass () {
      let result = 'btn-success'
      if (this.device.failure && this.device.failure.errors) {
        this.device.failure.errors.forEach((error) => {
          if (error.error_type.toUpperCase() === 'PRINTER_PROBLEM' || error.error_type.toUpperCase() === 'NO_PAPER') result = 'btn-danger'
        })
      }
      return result
    },
    printerPaperStatusClass () {
      let result = 'btn-success'
      if (this.device.failure && this.device.failure.errors) {
        this.device.failure.errors.forEach((error) => {
          if (error.error_type.toUpperCase() === 'PRINTER_LOW_PAPER') result = 'btn-warning'
          if (error.error_type.toUpperCase() === 'NO_PAPER') result = 'btn-danger'
        })
      }
      return result
    },
    terminalStatusClass () {
      let result = 'btn-success'
      if (this.device.failure && this.device.failure.errors) {
        this.device.failure.errors.forEach((error) => {
          if (error.error_type.toUpperCase() === 'TERMINAL_PROBLEM') result = 'btn-danger'
        })
      }
      return result
    }
  },
  methods: {
    isEnableVersionValid (version) {
      let result = false
      try {
        result = semver.satisfies(version, `>=${this.$store.getters.enableMinVersion}`)
      } catch (error) {
        // console.error('semver version error', error)
      }
      return result
    },
    openDetail () {
      this.$store.commit('SET_LOADER', false)
      this.$emit('openDetails', this.device)
    },
    hbStatusUpdate () {
      const self = this
      self.$data.ticker = new Date().getTime()
      if (self.device.hbtime && new Date().getTime() < self.device.hbtime + self.$store.state.config.heartbeatInterval * 2 * 1000) {
        self.$data.hbStatus = 'btn-success'
      } else {
        self.$data.hbStatus = 'btn-danger'
      }
    }
  },
  updated () {
    this.hbStatusUpdate()
  },
  created () {
    const self = this
    self.hbStatusUpdate()
    self.hbStatusSetInterval = setInterval(() => {
      self.hbStatusUpdate()
    }, 10 * 1000)
  }
}
</script>
<style lang="sass" scoped>
.spaceL
  margin-left: 20px
.secure
  display: inline
.prev
  position: absolute
  z-index: 999
  top: -1px
  left: 24px
  width: 90px * 3
  height: 160px * 3
  background-repeat: no-repeat
  background-size: contain
  background-color: black
.noWrap
  white-space: nowrap
  &.state
    button
      width: 27px
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceRow.vue